export default function (pluginsHandler) {
    return {
        name: 'collapse',
        treeMixins: {
            props: {
                collapseStartExpanded: {
                    type: Boolean,
                    default: false
                },
                collapseButtonCollapseExpandAll: {
                    type: Boolean,
                    default: false
                }
            },
            methods: {
                collapseExpandAll(root, isExpanded = true) {
                    root.forEach(child => {
                        if (child.isFolder)
                            child.open = isExpanded

                        if (child.$children.length > 0) {
                            this.collapseExpandAll(child.$children)
                        }
                    })
                },
                collapseCollapseAll(root) {
                    this.collapseExpandAll(root, false)
                },
                collapseChildExpandParents(child) {

                    while (child.$parent.rowItem && child.constructor.options.name === 'oc-tree-item') {
                        if (child.$parent.isFolder) {
                            child.$parent.open = true
                        }

                        return this.collapseChildExpandParents(child.$parent)
                    }
                },
                collapseToggle() {
                    if (this.collapseIsCollapsed) {
                        this.collapseExpandAll(this.$children)
                    } else {
                        this.collapseCollapseAll(this.$children)
                    }

                    this.collapseIsCollapsed = !this.collapseIsCollapsed
                }
            },
            data() {
                return {
                    collapseIsCollapsed: true,
                    collapseButtonText: ''
                }
            },
            watch: {
                collapseIsCollapsed() {
                    this.collapseButtonText = this.collapseIsCollapsed ? 'Expand' : 'Collapse'
                }
            },
            created() {
                this.collapseIsCollapsed = !this.collapseStartExpanded
                this.collapseButtonText = this.collapseIsCollapsed ? 'Expand' : 'Collapse'
            }
        },
        treeRowMixins: {
            data: function () {
                return {
                    open: false
                }
            },
            methods: {
                toggle: function () {
                    if (this.isFolder) {
                        this.open = !this.open
                    }
                },
            },
            mounted() {
                this.open = this.treeObject.collapseStartExpanded
            }
        },
        slotsContent: {
            beforeTree: '<oc-button-input class="btn btn-sm btn-default oc-tree-collapse-button-all" v-if="collapseButtonCollapseExpandAll" @click="collapseToggle">{{collapseButtonText}} All</oc-button-input>',
            'rowPrepend': `<span class="arrow oc-tree-collapse-folder" @click="toggle" v-if="isFolder">{{open ? '-' : '+'}}</span> ${pluginsHandler.getSlotContent('custom')}`
        }
    }
}
